import { NgModule } from '@angular/core';

import localPagesPathsConstants, {
  localPagePathsConstantsToken,
} from './local-pages-paths.constants';
import localPagesZipConstants, {
  localPageZipConstantsToken,
} from './local-pages-zips.constants';
import { pageUrlConstants, pageUrlConstantsToken } from './page-url.constants';
import statesConstants, { statesConstantsToken } from './states.constants';

@NgModule({
  providers: [
    { provide: pageUrlConstantsToken, useValue: pageUrlConstants },
    {
      provide: localPagePathsConstantsToken,
      useValue: localPagesPathsConstants,
    },
    { provide: localPageZipConstantsToken, useValue: localPagesZipConstants },
    { provide: statesConstantsToken, useValue: statesConstants },
  ],
})
export class ConstantsModule {}
